module.exports = __webpack_public_path__ + "static/media/icons.faff9214.woff";